export const Options = {
    BecomingAwareThrough: [
        { text: "Azubiyo", value: "Azubiyo" },
        { text: "Empfehlung eines/r Mitarbeitenden", value: "Empfehlung eines/r Mitarbeitenden" },
        { text: "frühstarter", value: "frühstarter" },
        { text: "Internetrecherche", value: "Internetrecherche" },
        { text: "Iurastudent", value: "Iurastudent" },
        { text: "Jobmensa", value: "Jobmensa" },
        { text: "MeinPraktikum", value: "MeinPraktikum" },
        { text: "Messe / Karrieremesse", value: "Messe / Karrieremesse" },
        { text: "Möhrle Happ Luther Website", value: "Möhrle Happ Luther Website" },
        { text: "Möhrle Happ Luther Workshop", value: "Möhrle Happ Luther Workshop" },
        { text: "Personalvermittlung", value: "Personalvermittlung" },
        { text: "Social Media (Instagram & Facebook)", value: "Social Media (Instagram & Facebook)" },
        { text: "Social Media (LinkedIn)", value: "Social Media (LinkedIn)" },
        { text: "Stellenwerk", value: "Stellenwerk" },
        { text: "Stepstone", value: "Stepstone" },
        { text: "StudyDrive", value: "StudyDrive" },
        { text: "Talenrocket", value: "Talenrocket" },
    ]
}
